// Registro del Service Worker para soporte offline (Local-First).
// En desarrollo el SW no se registra para no interferir con hot reload.

const SW_RESET_KEY = 'sw-reset'
const SW_SCRIPT_MISSING_KEY = 'sw-script-missing'

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export function markServiceWorkerReset() {
  sessionStorage.setItem(SW_RESET_KEY, '1')
}

export function isServiceWorkerScript(response) {
  if (response.status === 404) return false
  const contentType = response.headers.get('content-type')
  if (contentType && !contentType.includes('javascript')) return false
  return true
}

export async function clearServiceWorkerAndCaches() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map(registration => registration.unregister()))
  }
  if (typeof caches !== 'undefined' && caches.keys) {
    const keys = await caches.keys()
    await Promise.all(keys.map(key => caches.delete(key)))
  }
}

function listenForControllerChange() {
  const arrivedAfterReset = sessionStorage.getItem(SW_RESET_KEY) === '1'
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // El reset del modal y la baja por script ausente ya recargan ellos mismos.
    // clientsClaim() del worker nuevo también dispara este evento: si esta
    // carga viene de ese reset, no recargar otra vez.
    if (sessionStorage.getItem(SW_RESET_KEY) === '1' || sessionStorage.getItem(SW_SCRIPT_MISSING_KEY) === '1') {
      if (arrivedAfterReset) sessionStorage.removeItem(SW_RESET_KEY)
      return
    }
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })
}

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) return

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
      listenForControllerChange()
      checkValidServiceWorker(swUrl, config)
      if (isLocalhost) {
        navigator.serviceWorker.ready.then(() => {
          console.log('[SW] Modo localhost: SW activo con soporte offline.')
        })
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (!installingWorker) return

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Nueva versión disponible — el SW enviará SKIP_WAITING
              installingWorker.postMessage({ type: 'SKIP_WAITING' })
              if (config && config.onUpdate) config.onUpdate(registration)
            } else {
              // Primera instalación
              if (config && config.onSuccess) config.onSuccess(registration)
            }
          }
        }
      }
    })
    .catch(error => {
      console.error('[SW] Error al registrar:', error)
    })
}

export async function checkValidServiceWorker(swUrl, config, { fetchImpl = fetch, reload = () => window.location.reload() } = {}) {
  let response
  try {
    response = await fetchImpl(swUrl, {
      cache: 'no-store',
      headers: { 'Service-Worker': 'script' },
    })
  } catch {
    console.log('[SW] Sin conexión. La app corre en modo offline.')
    return
  }

  if (isServiceWorkerScript(response)) {
    sessionStorage.removeItem(SW_SCRIPT_MISSING_KEY)
    registerValidSW(swUrl, config)
    return
  }

  const registrations = navigator.serviceWorker.getRegistrations
    ? await navigator.serviceWorker.getRegistrations()
    : []
  if (registrations.length === 0) {
    sessionStorage.removeItem(SW_SCRIPT_MISSING_KEY)
    return
  }
  if (sessionStorage.getItem(SW_SCRIPT_MISSING_KEY) === '1') return

  sessionStorage.setItem(SW_SCRIPT_MISSING_KEY, '1')
  await clearServiceWorkerAndCaches()
  reload()
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => registration.unregister())
      .catch(error => console.error(error.message))
  }
}
